export const DIRECTIONS = {
  OUTBOUND: "outbound",
  INBOUND: "inbound",
} as const;

export type Direction = (typeof DIRECTIONS)[keyof typeof DIRECTIONS];

export const DIRECTION_LABELS = {
  OUTBOUND: "Ida",
  INBOUND: "Vuelta",
} as const;

export const DIRECTIONS_LIST = Object.values(DIRECTIONS);
